import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Injection } from "@customTypes/injection";


export const useCreateInjection = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: (injection: Partial<Injection>) => {
      return api.post("injections/", {
        consultation_id: injection.consultationId,
        service: injection.service,
        consumables: injection.consumables,
        patient_id: injection.patientId,
        note: injection.reason,
      });
    },
    onSuccess: (_, variables) => {
      // import.meta.env.DEV && console.log(res.data);
      showSuccessNotification({
        title: "success",
        message: "create-injection-success",
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.patientId as string),
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.injectionsWithFilters(
          variables.consultationId as string
        ),
      });
    },

    onError: (res, variables) => {
      console.error("[From Create Injection]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.injectionsWithFilters(
          variables.consultationId as string
        ),
      });

      handleErrors(res, "mutation");
    },
  });
};
